// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Mj46","placeholdersHeader":"styles_placeholdersHeader__dxdgw","editorStyle":"styles_editorStyle__1Nx5G","placeholdersBox":"styles_placeholdersBox__2ALg1"};